import { render, staticRenderFns } from "./CrearMovimiento.vue?vue&type=template&id=42130c9b"
import script from "./CrearMovimiento.vue?vue&type=script&lang=js"
export * from "./CrearMovimiento.vue?vue&type=script&lang=js"
import style0 from "./CrearMovimiento.vue?vue&type=style&index=0&id=42130c9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports